import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import PropTypes from "prop-types";
import { getCurrencySign } from "../../store/common";
import { getTranslate } from "react-localize-redux";
import {
  getSearchTerm,
  searchProduct,
  getSearchedProducts,
  clearSearch,
  setSearchTerm,
  importSearchedProducts,
  openProductModal
} from "../../store/product";
import { RingLoader } from "react-spinners";
import debounce from "lodash/debounce";
import { productImageThumbnailPath } from "../../utils/product.util";
import { browserHistory } from "react-router";
import shop from "../../api/shop";

class SearchContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      compatibilityTerm: null,
      compatibilityLoading: false,
      compatibilityList: []
    };
  }

  searchCompatibility = debounce(value => {
    this.setState({ compatibilityLoading: true, compatibilityList: [] });
    shop.searchCompatibility(
      this.state.compatibilityTerm,
      searchedCompatibilityFromApi => {
        searchedCompatibilityFromApi.then(searchedCompatibility => {
          this.setState({
            compatibilityLoading: false,
            compatibilityList: searchedCompatibility
          });
        });
      }
    );
  }, 500);

  searchProduct = compatibilityId => search;

  render() {
    const {
      getSearchTerm,
      setSearchTerm,
      search,
      getSearchedProducts,
      isSearchLoading,
      clearSearch,
      currencySign,
      importProducts,
      translate,
      openProductModal
    } = this.props;
    const {
      compatibilityLoading,
      compatibilityList,
      compatibilityTerm
    } = this.state;
    return (
      <div className="header__search">
        <input
          type="search"
          name="search"
          placeholder={translate(
            "containers.search.searchContainer.product_search"
          )}
          value={compatibilityTerm}
          onChange={e => {
            // setSearchTerm(e.target.value);
            // search(e.target.value);

            this.setState({ compatibilityTerm: e.target.value });
            this.searchCompatibility(e.target.value);
          }}
        />
        <button
          type="button"
          onClick={() => {
            this.setState({
              compatibilityList: [],
              compatibilityTerm: "",
              compatibilityLoading: false
            });
            clearSearch();
          }}
        >
          <i
            className={
              "fa fa-fw " + (!compatibilityTerm ? "fa-search" : "fa-close")
            }
          />
        </button>

        {compatibilityLoading && (
          <div className="header__search__results open">
            <div className="spinner-m10">
              <RingLoader color={"#e2001a"} loading={compatibilityLoading} />
            </div>
          </div>
        )}

        {compatibilityList.length > 0 && (
          <div className="header__search__results open">
            {compatibilityList.map((c, index) => (
              <Link
                key={index}
                // to={"/product/" + p.id + "/" + p.slug}
                className="header__search__results__item"
                onClick={() => {
                  this.setState({
                    compatibilityList: [],
                    compatibilityTerm: "",
                    compatibilityLoading: false
                  });
                  // search(c.id);
                  // setSearchTerm(compatibilityTerm);
                  importProducts(c.id, c.name);
                  clearSearch();
                }}
              >
                <div className="header__search__results__item__desc">
                  {c.name}
                </div>
              </Link>
            ))}
          </div>
        )}
        {/*
        <div className={"header__search__results" + (getSearchTerm ? " open" : "")}>
          {getSearchedProducts && !isSearchLoading ? (
            getSearchedProducts.slice(0, 5).map((p, index) => (
              <div
                key={index}
                className="header__search__results__item"
                onClick={() => {
                  clearSearch();
                  openProductModal(p.id);
                }}
              >
                <div className="header__search__results__item__img">
                  <img
                    src={productImageThumbnailPath(p.image, p.id)}
                    alt={p.title}
                  />
                </div>
                <div className="header__search__results__item__desc">
                  {p.title}
                  <span>{p.code}</span>
                </div>
                <div className="header__search__results__item__price">
                  {p.price} {currencySign}
                </div>
              </div>
            ))
          ) : (
              <div className="spinner-m10">
                <RingLoader color={"#d42e2b"} loading={isSearchLoading} />
              </div>
            )}
          <button
            type="button"
            onClick={() => importProducts()}
            className="btn w-100 header__search__results__allProducts"
          >
            {translate("containers.search.searchContainer.all_products")}(
        {getSearchedProducts.length})
      </button>
        </div>
            */}
      </div>
    );
  }
}

SearchContainer.propTypes = {
  getSearchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func,
  search: PropTypes.func,
  getSearchedProducts: PropTypes.shape(),
  isSearchLoading: PropTypes.bool,
  clearSearch: PropTypes.func,
  currencySign: PropTypes.string,
  importProducts: PropTypes.func,
  openProductModal: PropTypes.func,
  translate: PropTypes.func
};

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  getSearchTerm: getSearchTerm(state.product.searchBy),
  getSearchedProducts: getSearchedProducts(state.product.searchList),
  currencySign: getCurrencySign(state.common.user.currency.sign),
  isSearchLoading: state.product.loadingSearch
});

const mapDispatchToProps = dispatch => ({
  clearSearch: () => dispatch(clearSearch()),
  setSearchTerm: val => dispatch(setSearchTerm(val)),
  // search: debounce(val => {
  //   dispatch(searchProduct(val));
  // }, 500),

  importProducts: (id, term) => {
    browserHistory.push({
      pathname: `/search/${id}/${term}`,
      state: { search: id, term: term }
    });
    dispatch(importSearchedProducts());
  },
  openProductModal: id => dispatch(openProductModal(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchContainer);



// WEBPACK FOOTER //
// ./src/containers/Search/SearchContainer.js